<script>
import appConfig from "@/app.config";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import _ from "lodash";
import Swal from "sweetalert2";
// import moment from "moment";

export default {
  page: {
    title: "Penjadwalan",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Datatable,
    Pagination,
  },
  data() {
    let columns = [
      { width: "50px", label: "No", name: "-" },
      { width: "auto", label: "Pelaksanaan", name: "-" },
      { width: "auto", label: "Kode Tes", name: "-" },
      { width: "auto", label: "Batch", name: "-" },
      { width: "auto", label: "Tanggal Batch", name: "-" },
      { width: "auto", label: "NIP", name: "-" },
      { width: "auto", label: "Peserta", name: "-" },
      { width: "auto", label: "Job Code", name: "-" },
      { width: "auto", label: "Jabatan", name: "-" },
      { width: "auto", label: "Unit", name: "-" },
      { width: "auto", label: "Kompetensi", name: "-" },
      { width: "auto", label: "Level", name: "-" },
      { width: "auto", label: "Tipe Kompetensi", name: "-" },
      { width: "auto", label: "Survei", name: "-" },
    ];
    return {
      isWrite: localStorage.getItem("isWrite"),
      title: "Jawaban Peserta",
      items: [
        {
          text: "Report Hasil",
          active: false,
        },
        {
          text: "Kompetensi Peserta",
          active: true,
        },
      ],
      isLoading: false,
      columns: columns,
      tableFilter: {
        page: 1,
        per_page: 10,
        nip: "",
        nama: "",
        status: 1,
        pelaksanaan: [],
        idjadwal: "",
        nama_batch: "",
        jabatan: "",
        kompetensi: "",
        unit: "",
        level: "",
        job_code: "",
        tipe_kompetensi: "",
        kode_tes_active: localStorage.kode_tes_active,
      },
      tableData: [],
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
      optionFilterPelaksanaan: [],
      optionFilterJadwal: [],
      optionFilterBatch: [],
      optionFilterJabatan: [],
      optionFilterKompetensi: [],
      optionFilterLevel: [],
      optionFilterNama: [],
      optionFilterNip: [],
      optionFilterUnit: [],
      optionFilterTipeKompetensi: [],
      optionFilterJobCode: [],
      filterPelaksanaan: null,
      filterJadwal: null,
      filterBatch: null,
      filterJabatan: null,
      filterKompetensi: null,
      filterLevel: null,
      filterNama: null,
      filterNip: null,
      filterUnit: null,
    };
  },
  mounted() {
    this.getData();
    this.getFilterPelaksanaan();
    this.getFilterJadwal();
    this.getFilterBatch();
    this.getFilterJabatan();
    this.getFilterKompetensi();
    this.getFilterLevel();
    this.getFilterNama();
    this.getFilterNip();
    this.getFilterUnit();
    this.getFilterTipeKompetensi();
    this.getFilterJobCode();

    this.filterPelaksanaan = _.debounce(this.searchPelaksanaan.bind(this), 500);
    this.filterJadwal = _.debounce(this.searchJadwal.bind(this), 500);
    this.filterBatch = _.debounce(this.searchBatch.bind(this), 500);
    this.filterJabatan = _.debounce(this.searchJabatan.bind(this), 500);
    this.filterKompetensi = _.debounce(this.searchKompetensi.bind(this), 500);
    this.filterNama = _.debounce(this.searchNama.bind(this), 500);
    this.filterNip = _.debounce(this.searchNip.bind(this), 500);
    this.filterUnit = _.debounce(this.searchUnit.bind(this), 500);
    this.filterTipeKompetensi = _.debounce(
      this.searchTipeKompetensi.bind(this),
      500
    );
    this.filterJobCode = _.debounce(this.searchJobCode.bind(this), 500);
  },
  methods: {
    async getData(resetPage = true) {
      this.tableFilter.page = resetPage ? 1 : this.tableFilter.page;
      this.isLoading = true;
      const data = await axios({
        methods: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "report-hasil/survei-peserta",
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
        },
        params: this.tableFilter,
      })
        .then((response) => response.data)
        .catch((err) => {
          let errResponse = err.response.data;
          if (errResponse.meta?.code == 403) {
            Swal.fire({
              icon: "error",
              title: "Terjadi Kesalahan",
              text: errResponse.meta.message,
            });
            this.$router.push({ name: "logout" });
            return false;
          }
          Swal.fire({
            icon: "error",
            title: "Terjadi Kesalahan",
            text: errResponse.data,
          });

          console.log(errResponse);
          return false;
        });
      if (data) {
        if (data.meta.code == 403) {
          this.$router.push("logout");
        } else if (data.meta.code == 200) {
          this.tableData = data.data.data;
          this.pagination.lastPage = data.data.last_page;
          this.pagination.currentPage = data.data.current_page;
          this.pagination.total = data.data.total;
          this.pagination.lastPageUrl = data.data.last_page_url;
          this.pagination.nextPageUrl = data.data.next_page_url;
          this.pagination.prevPageUrl = data.data.prev_page_url;
          this.pagination.from = data.data.from;
          this.pagination.to = data.data.to;
          this.pagination.links = data.data.links;
        }
      }
      this.isLoading = false;
    },
    toPage(url) {
      let link = new URLSearchParams(url);
      this.tableFilter.page = link.get("page");
      // this.tableFilter.per_page = link.get('per_page');
      this.getData(false);
    },
    searchJobCode(search, loading) {
      loading(true);
      this.getFilterJobCode(loading, search);
    },
    async getFilterJobCode(loading, search) {
      const data = await axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/job-code/all",
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
        params: {
          search: search,
          limit: 50,
        },
      })
        .then((response) => response.data.data.data)
        .catch((err) => {
          console.log("err get job code and job name:", err);
          return [];
        });

      if (data) {
        console.log({data});
        this.optionFilterJobCode = data;
      }
      if (loading) loading(false);
    },
    async searchTipeKompetensi(search, loading) {
      loading(true);
      this.getFilterTipeKompetensi(search, loading);
    },
    async getFilterTipeKompetensi(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "referensi/tipe_kompetensi/all",
          {
            params: {
              search: search,
              limit: 50,
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          this.optionFilterTipeKompetensi = response.data.data;
          if (loading) loading(false);
        });
    },
    async getFilterPelaksanaan(search = "", loading) {
      await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "referensi/jadwal-pelaksanaan/all",
        params: {
          search: search,
          limit: 10,
        },
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
        },
      }).then((response) => {
        this.optionFilterPelaksanaan = response.data.data;
        if (loading) loading(false);
      });
    },
    async searchPelaksanaan(search, loading) {
      if (search.length) {
        loading(true);
        this.getFilterPelaksanaan(search, loading);
      }
    },
    async searchJadwal(search, loading) {
      if (search.length) {
        loading(true);
        this.getFilterJadwal(search, loading);
      }
    },
    async getFilterJadwal(search = "", loading) {
      await axios
        .get(process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/jadwal/all", {
          params: {
            search: search,
            limit: 10,
            kode_tes_active: localStorage.kode_tes_active,
          },
          headers: {
            Authorization: "Bearer " + localStorage.access_token,
          },
        })
        .then((response) => {
          this.optionFilterJadwal = response.data.data;
          if (loading) loading(false);
        });
    },
    async searchBatch(search, loading) {
      if (search.length) {
        loading(true);
        this.getFilterBatch(search, loading);
      }
    },
    async getFilterBatch(search = "", loading) {
      await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "referensi/jadwal-batch/all",
        params: {
          search: search,
          limit: 10,
        },
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
        },
      }).then((response) => {
        this.optionFilterBatch = response.data.data;
        if (loading) loading(false);
      });
    },
    async searchJabatan(search, loading) {
      if (search.length) {
        loading(true);
        this.getFilterJabatan(search, loading);
      }
    },
    async getFilterJabatan(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "referensi/jabatan-kompetensi/all",
          {
            params: {
              search: search,
              limit: 10,
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          this.optionFilterJabatan = response.data.data;
          if (loading) loading(false);
        });
    },
    async searchKompetensi(search, loading) {
      if (search.length) {
        loading(true);
        this.getFilterKompetensi(search, loading);
      }
    },
    async getFilterKompetensi(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/kompetensi/all",
          {
            params: {
              search: search,
              limit: 10,
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          this.optionFilterKompetensi = response.data.data;
          if (loading) loading(false);
        });
    },
    async searchNama(search, loading) {
      if (search.length) {
        loading(true);
        this.getFilterNama(search, loading);
      }
    },
    async getFilterNama(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "referensi/report-hasil/all",
          {
            params: {
              search: search,
              limit: 10,
              tab: "survei",
              col: "nama",
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          this.optionFilterNama = response.data.data;
          if (loading) loading(false);
        });
    },
    async searchNip(search, loading) {
      if (search.length) {
        loading(true);
        this.getFilterNip(search, loading);
      }
    },
    async getFilterNip(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "referensi/report-hasil/all",
          {
            params: {
              search: search,
              limit: 10,
              tab: "survei",
              col: "nip",
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          this.optionFilterNip = response.data.data;
          if (loading) loading(false);
        });
    },
    async searchUnit(search, loading) {
      if (search.length) {
        loading(true);
        this.getFilterUnit(search, loading);
      }
    },
    async getFilterUnit(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "referensi/report-hasil/all",
          {
            params: {
              search: search,
              limit: 10,
              tab: "survei",
              col: "unit",
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          this.optionFilterUnit = response.data.data;
          if (loading) loading(false);
        });
    },
    async getFilterLevel(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "referensi/level-kompetensi/all",
          {
            params: {
              search: search,
              limit: 10,
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          this.optionFilterLevel = response.data.data.data;
          if (loading) loading(false);
        });
    },
    exportData() {
      let params = new URLSearchParams(this.tableFilter).toString();
      window.open(
        process.env.VUE_APP_BACKEND_URL_VERSION +
          "report-hasil/export-excel/survei-peserta?" +
          params
      );
    },
  },
};
</script>
<template>
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="d-flex justify-content-between">
          <div class="card-title">Survei Peserta</div>
          <div class="d-flex gap-2">
            <button
              class="btn btn-sm btn-primary"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFilterReportSurvei"
              aria-expanded="false"
              aria-controls="collapseFilterReportSurvei"
            >
              <i class="fa fa-filter me-1"></i> Filter Data
            </button>
            <button
              class="btn btn-sm btn-success"
              @click="exportData()"
              v-if="isWrite == 1"
            >
              <i class="fa fa-file-excel me-1"></i> Export Report Peserta
            </button>
          </div>
        </div>
        <div class="col-md-12">
          <hr />
          <div class="collapse" id="collapseFilterReportSurvei">
            <div class="row">
              <div class="col-md-4 mt-2">
                <label for="filterPelaksanaan">Pelaksanaan</label>
                <v-select
                  id="parent_menu"
                  class="style-chooser"
                  :options="optionFilterPelaksanaan"
                  :reduce="(pelaksanaan) => pelaksanaan.idjadwal_pelaksanaan"
                  label="pelaksanaan"
                  v-model="tableFilter.pelaksanaan"
                  placeholder="Filter Pelaksanaan"
                  :multiple="true"
                  @search="filterPelaksanaan"
                  @update:modelValue="getData"
                >
                </v-select>
              </div>
              <div class="col-md-4 mt-2">
                <label for="filterJadwal">Jadwal</label>
                <v-select
                  id="parent_menu"
                  class="style-chooser"
                  :options="optionFilterJadwal"
                  :reduce="(jadwal) => jadwal.idjadwal"
                  label="kode_tes"
                  v-model="tableFilter.idjadwal"
                  placeholder="Filter Jadwal"
                  @search="filterJadwal"
                  @update:modelValue="getData"
                >
                </v-select>
              </div>
              <div class="col-md-4 mt-2">
                <label for="filterBatch">Batch</label>
                <v-select
                  id="parent_menu"
                  class="style-chooser"
                  :options="optionFilterBatch"
                  :reduce="(batch) => batch.nama_batch"
                  label="nama_batch"
                  v-model="tableFilter.nama_batch"
                  placeholder="Filter Jabatan"
                  @search="filterBatch"
                  @update:modelValue="getData"
                >
                </v-select>
              </div>
              <div class="col-md-4 mt-2">
                <label for="filterJabatan">Jabatan</label>
                <v-select
                  id="parent_menu"
                  class="style-chooser"
                  :options="optionFilterJabatan"
                  :reduce="(jabatan) => jabatan.nama_jabatan"
                  label="nama_jabatan"
                  v-model="tableFilter.jabatan"
                  placeholder="Filter Jabatan"
                  @search="filterJabatan"
                  @update:modelValue="getData"
                >
                </v-select>
              </div>
              <div class="col-md-4 mt-2">
                <label for="filterJobCode">Job Code</label>
                <v-select
                  id="parent_menu"
                  class="style-chooser"
                  :options="optionFilterJobCode"
                  :reduce="(data) => data.kode_job"
                  label="kode_job"
                  v-model="tableFilter.job_code"
                  placeholder="Filter Job Code"
                  @search="filterJobCode"
                  @update:modelValue="getData"
                >
                </v-select>
              </div>
              <div class="col-md-4 mt-2">
                <label for="filterTipeKompetensi">Tipe Kompetensi</label>
                <v-select
                  id="parent_menu"
                  class="style-chooser"
                  :options="optionFilterTipeKompetensi"
                  :reduce="(data) => data.tipe_kompetensi"
                  label="tipe_kompetensi"
                  v-model="tableFilter.tipe_kompetensi"
                  placeholder="Filter Tipe Kompetensi"
                  @search="filterTipeKompetensi"
                  @update:modelValue="getData"
                >
                </v-select>
              </div>
              <div class="col-md-4 mt-2">
                <label for="filterKompetensi">Kompetensi</label>
                <v-select
                  id="parent_menu"
                  class="style-chooser"
                  :options="optionFilterKompetensi"
                  :reduce="(komptensi) => komptensi.nama_kompetensi"
                  label="nama_kompetensi"
                  v-model="tableFilter.kompetensi"
                  placeholder="Filter Kompetensi"
                  @search="filterKompetensi"
                  @update:modelValue="getData"
                >
                </v-select>
              </div>
              <div class="col-md-4 mt-2">
                <label for="filterNama">Nama</label>
                <v-select
                  id="parent_menu"
                  class="style-chooser"
                  :options="optionFilterNama"
                  :reduce="(item) => item.nama"
                  label="nama"
                  v-model="tableFilter.nama"
                  placeholder="Filter Nama"
                  @search="filterNama"
                  @update:modelValue="getData"
                >
                </v-select>
              </div>
              <div class="col-md-4 mt-2">
                <label for="FilterNIP">NIP</label>
                <v-select
                  id="parent_menu"
                  class="style-chooser"
                  :options="optionFilterNip"
                  :reduce="(item) => item.nip"
                  label="nip"
                  v-model="tableFilter.nip"
                  placeholder="Filter NIP"
                  @search="filterNip"
                  @update:modelValue="getData"
                >
                </v-select>
              </div>
              <div class="col-md-4 mt-2">
                <label for="FilterUnit">Unit</label>
                <v-select
                  id="parent_menu"
                  class="style-chooser"
                  :options="optionFilterUnit"
                  :reduce="(item) => item.unit"
                  label="unit"
                  v-model="tableFilter.unit"
                  placeholder="Filter Unit"
                  @search="filterUnit"
                  @update:modelValue="getData"
                >
                </v-select>
              </div>
              <div
                class="col-md-4 mt-2 d-flex align-items-end justify-content-end gap-2"
              >
                <div class="form-group flex-fill">
                  <label for="FilterUnit">Level</label>
                  <v-select
                    id="parent_menu"
                    class="style-chooser"
                    :options="optionFilterLevel"
                    :reduce="(level) => level.nama_level"
                    label="nama_level"
                    v-model="tableFilter.level"
                    placeholder="Filter Level"
                    @update:modelValue="getData"
                  >
                  </v-select>
                </div>
              </div>
            </div>
            <hr />
          </div>
        </div>
        <div class="col-md-12 mb-2">
          <div class="row">
            <div class="col-md-4">
              <table>
                <tr>
                  <td>Show</td>
                  <td>
                    <select
                      class="form-control form-control-sm"
                      id="showpaginatetable"
                      style="width: 100%"
                      v-model="tableFilter.per_page"
                      @change="getData"
                    >
                      <option value="10" selected>10</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </select>
                  </td>
                  <td>Entries</td>
                </tr>
              </table>
            </div>
            <div class="col-md-5">&nbsp;</div>
            <div class="col-md-3">
              <!-- <input
                type="text"
                class="form-control form-control-sm"
                id="searchTable"
                placeholder="Cari Data ..."
                v-model="tableData.search"
                @input="getDataTable()"
              /> -->
            </div>
          </div>
        </div>
        <datatable :columns="columns">
          <tbody>
            <tr v-if="isLoading">
              <td colspan="99" class="text-center">
                <i class="fas fa-spinner fa-spin"></i> Loading...
              </td>
            </tr>
            <tr v-else-if="tableData == ''">
              <td class="text-center" colspan="99">Data Tidak Tersedia</td>
            </tr>
            <tr v-else v-for="(row, index) in tableData" :key="index">
              <td class="text-center">
                {{ index + pagination.from }}
              </td>
              <td>
                {{ row.pelaksanaan }}
              </td>
              <td>
                {{ row.kode_tes }}
              </td>
              <td>
                {{ row.nama_batch }}
              </td>
              <td>
                {{ row.waktu_mulai }}
              </td>
              <td>
                {{ row.nip }}
              </td>
              <td>
                {{ row.nama }}
              </td>
              <td>
                {{ row.kode_job }}
              </td>
              <td>
                {{ row.jabatan_asesmen }}
              </td>
              <td>
                {{ row.unit }}
              </td>
              <td>
                {{ row.nama_kompetensi }}
              </td>
              <td>
                {{ row.nama_level }}
              </td>
              <td>
                {{ row.tipe_kompetensi }}
              </td>
              <td>
                {{ row.kritik_saran }}
              </td>
            </tr>
          </tbody>
        </datatable>
      </div>
      <pagination :pagination="pagination" @to-page="toPage"></pagination>
    </div>
  </div>
</template>
